import { ThemeProvider } from '@mui/material';
import { MotionConfig } from 'framer-motion';

import { appTheme } from '@/styles/theme';
import { MOTION_TRANSITION } from '@/tracker/config/motion';
import { TrackerStoreProvider } from '@/tracker/model';

import { TrackerLayoutContent } from './TrackerLayoutContent';

/** Оболочка вкладки «Трекер»: своя навигация слева, экраны трекера справа, карточка задачи поверх */
const TrackerLayout = () => (
  <ThemeProvider theme={appTheme}>
    <MotionConfig transition={MOTION_TRANSITION} reducedMotion="user">
      <TrackerStoreProvider>
        <TrackerLayoutContent />
      </TrackerStoreProvider>
    </MotionConfig>
  </ThemeProvider>
);

export { TrackerLayout };
